/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const orderPayCreatePathOrderIdSchema = z.uuid();

export const orderPayCreateStatus200Schema = z.any();

export const orderPayCreateResponseSchema = orderPayCreateStatus200Schema;
